import React, { ComponentProps } from 'react';
import { Paper } from "@mui/material";

const StyledPaper: React.FC<ComponentProps<typeof Paper>> = (props) => {
    return <Paper 
    {...props}
    sx={{
        borderRadius: '16px',
        padding: '12px 16px 16px 16px',
        boxShadow:'0px 4px 20px -2px #3232470A, 0px 0px 1px 0px #0C1A4B08',
        ...props.sx
    }}
    elevation={0}
    />
}

export default StyledPaper;